<template>
    <div id="materiaux" class="box">
        <h2><span>3/4</span> {{ t('Matériel à décharger')}}</h2>
        <ul>
            <li v-for="type in wasteTypes" :key="type.id">
                <input v-on:click="selectMaterial" v-model="materials" class="checkbox" :value='type.id' type="checkbox" :id="'material-' + type.id" :checked="type.id in materials">
                <label :for="'material-' + type.id" class="label_container">
                    <div class="media" v-if="type.imageUrl">
                        <img :src="domain + '/' + type.imageUrl" alt="" class="image" />
                    </div>
                    <div class="label">
                        <h3>{{ type.name }}</h3>
<!--                        <p>{{ type.unitPrice }}€ / {{ type.unit }}</p>-->
                    </div>
                    <img src="../assets/ui/check-filled.svg" class="check" alt="">
                </label>
            </li>
        </ul>
<!--        <div class="file_container">-->
<!--            <label for="file" class="file__label">-->
<!--                <span v-if="imageFiles.length === 0">{{ t('Vous pouvez télécharger des images ici si vous le souhaitez… ')}}</span>-->
<!--                <span class="file__label__name" v-if="imageFiles.length >= 1">{{ fileMessage }}</span>-->
<!--                <span class="file__button" v-translate>télécharger</span>-->
<!--            </label>-->
<!--            <input type="file" @change="uploadFiles" id="file" class="file__input" accept="image/png, image/jpeg, image/gif, image/jpg" multiple>-->
<!--            <span v-if="fileSizeError" class="file__error">La taille de l'image ne peut pas surpasser 10MB</span>-->
<!--        </div>-->
    </div>
</template>

<script>
    const axios = require('axios');
    const objectFitImages = require('object-fit-images');


    export default {
        name: 'MaterialSelection',
        data: function() {
            return({
                materials: this.$store.state.materialSelection,
                wasteTypes: null,
                imageFiles: [],
                fileMessage: '',
                fileSizeError: false,
            })
        },
        mounted() {
            objectFitImages();
            axios
                .get(`${this.$store.state.domain}/api/fr/waste-types`)
                .then(response => {
                    this.wasteTypes = response.data;
                    this.$store.commit('changeData', {
                        type: 'availableWasteTypes',
                        value: this.wasteTypes,
                    })
                })
                .catch(error => {
                    if (error) {
                        this.$store.commit('addErrorMessage', error.response.data.extraData.message);
                        this.$store.commit('lockApp');
                    }
                })
            this.domain = this.$store.state.domain;
        },
        methods: {
            uploadFiles(event) {
                this.fileSizeError = false;
                this.imageFiles = [];
                this.fileMessage = '';
                event.target.files.forEach((file) => {
                  if (file.size > 10000000) {
                    event.target.value = "";
                    this.fileSizeError = true;
                    this.fileMessage = "Vous pouvez télécharger des images ici si vous le souhaitez… ";
                  } else {
                    this.imageFiles.push(file);
                    this.fileMessage = this.fileMessage + ", " + file.name;
                    this.fileMessage = this.fileMessage.substring(1);
                  }
                })
                this.$store.commit('changeData', {
                  type: 'imageFiles',
                  value: this.imageFiles,
                })
            },
            selectMaterial() {
                let v = this;
                setTimeout(function () {
                    v.$store.commit('changeData', {
                        type: 'materialSelection',
                        value: v.materials,
                    })

                }, 500);
            },
        }
    }
</script>

<style scoped>

    .box {
        margin-top: 80px;
    }

    h2 {
        color: var(--green--dark);
        text-align: center;
    }

    h2 span {
        display: block;
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
        font-size: 24px;
        margin-bottom: 15px;
    }

    @media only screen and (max-width: 500px) {
        h2 span {
            display: block;
            margin-bottom: 10px;
        }
    }

    ul {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
        gap: var(--xmedium);
    }

    li {
        background-color: white;
        border-bottom-right-radius: 100px;
        border-bottom-left-radius: 15px;
        border-top-right-radius: 15px;
        border-top-left-radius: 100px;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.17);
        color: var(--green--dark);
        margin-top: 30px;
        margin-left: 30px;
        padding: 80px 60px 30px 30px;
        position: relative;
    }

    @media only screen and (max-width: 500px) {
        li {
            padding: 80px 30px 30px 30px;
        }
    }

    .label_container:hover {
        cursor: pointer;
    }

    .label_container {
        transition: color 0.2s ease, background-color 0.2s ease;
    }

    .label_container::after {
        content: "";
        border-radius: 50%;
        border: 2px solid var(--green);
        height: 40px;
        position: absolute;
        top: 25px;
        right: 25px;
        width: 40px;
    }

    .label {
        display: block;
    }

    .label::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.17);
        border-bottom-right-radius: 100px;
        border-bottom-left-radius: 15px;
        border-top-right-radius: 15px;
        border-top-left-radius: 100px;
        z-index: 0;
    }

    .label h3 {
        font-size: 26px;
        font-weight: 700;
        margin-bottom: var(--small);
        position: relative;
        z-index: 1;
    }

    .label p {
        position: relative;
        z-index: 1;
    }

    .label p:nth-child(2) {
        font-weight: 700;
    }

    .checkbox {
        position: absolute;
        opacity: 0;
    }

    .check {
        position: absolute;
        top: 25px;
        right: 25px;
        visibility: hidden;
    }

    .checkbox:checked + .label_container .check {
        visibility: visible;
    }

    .checkbox:checked + .label_container {
        color: white;
    }

    .checkbox:checked + .label_container::after {
        border: 2px solid var(--green--light);
    }

    .checkbox:checked + .label_container .label::before {
        background-color: var(--green);
    }

    .checkbox:focus + .label_container .label::before {
        box-shadow: 0px 0px 2px 4px var(--green--light);
    }

    .media {
        border: 4px solid var(--green);
        border-radius: 50%;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.17);
        background-color: white;
        height: 110px;
        overflow: hidden;
        position: absolute;
        top: -30px;
        left: -30px;
        width: 110px;
        z-index: 1;
    }

    .image {
        height: 100%;
        font-family: 'object-fit: cover, object-position: center';
        object-fit: cover;
        object-position: center;
        width: 100%;
    }

    .file__label {
        border: 1px solid #DFEAD4;
        border-radius: 30px;
        color: var(--grey);
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 700;
        padding: 6px 6px 6px 15px;
        margin-top: var(--xxlarge);
        width: 100%;
    }

    @media only screen and (max-width: 500px) {
        .file__label {
            flex-direction: column;
            text-align: center;
            padding: 15px;
        }
    }

    .file__label:hover {
        cursor: pointer;
    }

    .file__button {
        background-color: var(--green);
        color: white;
        font-weight: 700;
        text-transform: uppercase;
        padding: 8px 30px;
        border-radius: 30px;
    }

    @media only screen and (max-width: 500px) {
        .file__button {
            margin-top: 30px;
        }
    }

    .file__input {
        position: absolute;
        opacity: 0;
    }

    .file__label__name {
        overflow: hidden;
        padding-right: var(--large);
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
    }

  .file__error {
    color: var(--orange);
    display: block;
    margin: 15px 0 0 15px;
  }
</style>
